export const ErrorMessage =
  "Model name must contain only lowercase letters, numbers, dashes, underscores, or periods, and may not start or end with a dash, underscore, or period";

export function validateModelName(modelName: string): string | undefined {
  // Regular expression breakdown:
  // ^                  - start of string
  // [a-z0-9]           - must start with lowercase letter or number
  // [a-z0-9-_\.]*      - can contain lowercase letters, numbers, dashes, underscores, periods
  // [a-z0-9]           - must end with lowercase letter or number
  // $                  - end of string
  const modelNameRegex = /^[a-z0-9][a-z0-9\-_.]*[a-z0-9]$|^[a-z0-9]$/;

  if (!modelNameRegex.test(modelName)) {
    return ErrorMessage;
  }
}
